import { Component, Input } from '@angular/core';

@Component({
  selector: 'hospitality-bot-info-note',
  templateUrl: './info-note.component.html',
  styleUrls: ['./info-note.component.scss'],
})
export class InfoNoteComponent {
  @Input() type: 'info' | 'warning' | 'danger' = 'info';
  @Input() icon?: string;
  @Input() text?: string;
  @Input() customClass?: string;
  @Input() customStyle?: Record<string, any>;

  get defaultIcon(): string {
    if (this.icon) return this.icon;
    if (this.type === 'danger' || this.type === 'warning') return 'pi pi-exclamation-triangle';
    return 'pi pi-info-circle';
  }
}
